const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://www.alexstzman.com',
  title: 'AS.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Alex Sitzman',
  role: 'Senior Technical Support Engineer at Microsoft Azure',
  currentLocation: 'Redmond, WA',
  // resume: 'www.alexsitzman.com',
  titles: ['Cloud Engineer', "Kubernetes Admin", "Full-Stack Developer"],
  social: {
    linkedin: 'https://www.linkedin.com/in/alexander-sitzman',
    github: 'https://github.com/sitzmana',
  },
}


const certs = [
  {
    name: 'Certified Kubernetes Administrator',
    provider: 'Cloud Native Computing Foundation',
    stack: ['Kubernetes','DevOps','CI/CD', 'Containers']
  },
  {
    name: 'Certified Linux Systems Administrator',
    provider: 'Linux Foundation',
    stack: ['Linux','Networks','Security']
  },
]

const social = {
  linkedin: 'https://www.linkedin.com/in/alexander-sitzman',
    github: 'https://github.com/sitzmana',
    dev: "https://dev.to/sitzmana",
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Virtual Internet Project',
    description:
      'Implementation of SEED emulator to create a lab environment for the purpose of Cybersecurity education. The program provides a contained environment that simulates a network of a given size and packets within it',
    stack: ['Python', 'Cybersecurity', 'Networks'],
    // sourceCode: 'https://github.com',
    livePreview: 'https://blog.alexsitzman.com/blogs/virtual-internet-emulation-for-cybersecurity-training',
  },
  {
    name: 'Kubernetes Raspberry Pi Cluster',
    description:
      'A cluster made of Raspberry Pis running Kubernetes to act as a home network ad-blocker, streaming center, cloud photo storage and vpn',
    stack: ['Kubernetes', 'Network Administration', 'Security'],
    // sourceCode: 'https://github.com',
    livePreview: 'https://blog.alexsitzman.com/blogs/pi-cluster',
  },
  {
    name: 'DAS Driver Windows/NetBSD',
    description:
      'A driver for a digital analog converter, utilizing a PCI bus. Built in both NetBSD and Windows environments, the device read from a varying voltage source and converts it into machine readable samples with time stamps',
    stack: ['C/C#', 'Hardware', 'Windows Driver Development'],
    sourceCode: 'https://github.com/sitzmaa/DASDriver',
    // livePreview: 'https://github.com',
  },
]

const currentProject = {
  name: 'AKS Mastodon Server',
  description: 'A personal mastodon server hosted on AKS',
  stack: ['Kubernetes', 'Azure', 'Administration'],
}

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Kubernetes',
  'Azure',
  'DevOps',
  'Network Security',
  'Go',
  'Python',
  'AWS',
  'Javascript',
  'Git',
  'CI/CD',
  'C++',
  'MicroServices',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'alexander@sitzman.net',
}

export { header, about, projects, certs, skills, contact, social, currentProject }
